// import Paragraph from "antd/lib/skeleton/Paragraph";
import config from "../../pages/Config";

export const FAQsteps = [
  {
    target: '.menustep1', // Dashboard item
    content: (
      <>
        <h3 bold size="lg" className="mb-4 text-green">
          Dashboard
        </h3>
        <h5 className="mb-0">
          This is Your Main Dashboard Page
        </h5>
      </>
    ),
    placement: 'right',
    disableBeacon: true,
    data: { action: 'click' },
    highlight: false,
    styles: {
      floater: {
        left: '120px !important'
      }}
  },
  {
    target: '.ps-card.Order-card-1', // Specific card
    content: (
      <>
        <h3 bold size="lg" className="mb-4 text-green">
          Ongoing Lessons
        </h3>
        <h5 className="mb-0">
          You can Check Upcomimg Slots of Ongoing Lessons Form This View
        </h5>
      </>
    ),
    placement: "left-top",
    data: { action: 'navigate', previous: `${config.appUrl}`, next: `${config.appUrl}calendar` },
    disableBeacon: true,
  },
  {
    target: '.menustep2', // Calendar item
    content: (
      <>
        <h3 bold size="lg" className="mb-4 text-green">
          Calender
        </h3>
        <h5 className="mb-0">
          This Page Shows you Calender View of all Your Lessons
        </h5>
      </>
    ),
    data: { action: 'click', previous: `${config.appUrl}` },
    // placement: 'left',
    disableBeacon: true,
  },
  {
    target: '.calender-container', // Specific card
    content: (
      <>
        <h3 bold size="lg" className="mb-4 text-green">
          Calendar Views
        </h3>
        <h5 className="mb-0">
          You can Check All Your Lesson in Month , Week and Day View
        </h5>
      </>
    ),
    data: { action: 'navigate', previous: `${config.appUrl}calendar`, next: `${config.appUrl}lessons` },
    placement: 'top-start',
    disableBeacon: true,
  },
  {
    target: '.menustep3', // Lessons item
    content: (
      <>
        <h3 bold size="lg" className="mb-4 text-green">
          Lessons Module
        </h3>
        <h5 className="mb-0">
          All Lessons Which You have to Complete Show Here.
        </h5>
      </>
    ),
    data: { action: 'click', previous: `${config.appUrl}calendar` },
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '.table-responsive', // Specific card
    content: (
      <>
        <h3 bold size="lg" className="mb-4 text-green">
          Lessons Module
        </h3>
        <h5 className="mb-0">
          You can Check All Your Lessons And Change Status of Lessons With Acceptance of Lesson , Time Slot Changes and Status Update of Completed Slots.
        </h5>
      </>
    ),
    data: { action: 'navigate', previous: `${config.appUrl}lessons`, next: `${config.appUrl}claim-history` },
    placement: 'top-start',
    disableBeacon: true,
  },
  {
    target: '.menustep4', // Payments item
    content: (
      <>
        <h3 bold size="lg" className="mb-4 text-green">
          Claims Module
        </h3>
        <h5 className="mb-0">
          In This Module All Claims of Completed Slots Will Show
        </h5>
      </>
    ),
    data: { action: 'click', previous: `${config.appUrl}lessons` },
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '.table-responsive', // Specific card
    content: (
      <>
        <h3 bold size="lg" className="mb-4 text-green">
          Claims Table
        </h3>
        <h5 className="mb-0">
          In This you can Check all Your Claims and Details of That
        </h5>
      </>
    ),
    data: { action: 'navigate', previous: `${config.appUrl}claim-history`, next: `${config.appUrl}students` },
    placement: 'top-start',
    disableBeacon: true,
  },
  {
    target: '.menustep5', // Support item
    content: (
      <>
        <h3 bold size="lg" className="mb-4 text-green">
          Students Module
        </h3>
        <h5 className="mb-0">
          All your Students will Show Here
        </h5>
      </>
    ),
    data: { action: 'click', previous: `${config.appUrl}claim-history` },
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '.table-responsive', // Specific card
    content: (
      <>
        <h3 bold size="lg" className="mb-4 text-green">
          Students Table
        </h3>
        <h5 className="mb-0">
          You can Check All Your Students Lesson Details Here.
        </h5>
      </>
    ),
    data: { action: 'navigate', previous: `${config.appUrl}students`, next: `${config.appUrl}courses` },
    placement: 'top-start',
    disableBeacon: true,
  },
  {
    target: '.menustep6', // Support item
    content: (
      <>
        <h3 bold size="lg" className="mb-4 text-green">
          Courses Module
        </h3>
        <h5 className="mb-0">
          All your Courses which Providing to Students will Show Here
        </h5>
      </>
    ),
    data: { action: 'click', previous: `${config.appUrl}students` },
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '.table-responsive', // Specific card
    content: (
      <>
        <h3 bold size="lg" className="mb-4 text-green">
          Courses Table
        </h3>
        <h5 className="mb-0">
          You can Check All Your Courses and Details Here.
        </h5>
      </>
    ),
    data: { action: 'navigate', previous: `${config.appUrl}courses`, next: `${config.appUrl}availability` },
    placement: 'top-start',
    disableBeacon: true,
  },
  {
    target: '.menustep7', // Support item
    content: (
      <>
        <h3 bold size="lg" className="mb-4 text-green">
          Slots Module
        </h3>
        <h5 className="mb-0">
          All your Slots in which Students can book Lessons will Show Here
        </h5>
      </>
    ),
    data: { action: 'click', previous: `${config.appUrl}courses` },
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '.table-responsive', // Specific card
    content: (
      <>
        <h3 bold size="lg" className="mb-4 text-green">
          Slots Table
        </h3>
        <h5 className="mb-0">
          You can set Diffrent timeSlot for all Days from Here.
        </h5>
      </>
    ),
    data: { action: 'navigate', previous: `${config.appUrl}availability`, next: `${config.appUrl}support` },
    placement: 'top-start',
    disableBeacon: true,
  },
  {
    target: '.menustep8', // Support item
    content: (
      <>
        <h3 bold size="lg" className="mb-4 text-green">
          Support Module
        </h3>
        <h5 className="mb-0">
          All your Questions with Admin will Show Here.
        </h5>
      </>
    ),
    data: { action: 'click', previous: `${config.appUrl}availability` },
    placement: 'right',
    disableBeacon: true,
  },
  {
    target: '.table-responsive', // Specific card
    content: (
      <>
        <h3 bold size="lg" className="mb-4 text-green">
          Support Table
        </h3>
        <h5 className="mb-0">
          You can Check All Your Query's Details Here
        </h5>
      </>
    ),
    data: { action: 'navigate', previous: `${config.appUrl}support`, next: `${config.appUrl}profile` },
    placement: 'top-start',
    disableBeacon: true,
  },
  {
    target: '.menustep9', // Profile item
    content: (
      <>
        <h3 bold size="lg" className="mb-4 text-green">
          Profile Module
        </h3>
        <h5 className="mb-0">
          You can Manage All Your Details from This Page.
        </h5>
      </>
    ),
    data: { action: 'click', previous: `${config.appUrl}support` }, // End of the walkthrough
    placement: 'auto',
    disableBeacon: true,
  },
  {
    target: '.therapist-profile-form', // Specific card
    content: (
      <>
        <h3 bold size="lg" className="mb-4 text-green">
          Personal Details
        </h3>
        <h5 className="mb-0">
          Your All Personal details Will Show Here which is shared with us.
        </h5>
      </>
    ),
    data: { action: 'end', previous: `${config.appUrl}profile` },
    placement: 'top-start',
    disableBeacon: true,
  },
]